import Vue from 'vue'
import { registerLicense } from '@syncfusion/ej2-base'
import App from './App.vue'
import app from './app'
import router from './router'
import store from './store'

import { Auth0Plugin } from '@/plugins/auth0'
import vuetify from '@/plugins/vuetify'
import logger from '@/plugins/logger'
import i18n from '@/plugins/i18n'
import alert from '@/plugins/alert'
import confirm from '@/plugins/confirm'
import wordpress from '@/plugins/wordpress'

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import ErrorLayout from '@/layouts/ErrorLayout.vue'

import './registerServiceWorker'

registerLicense(process.env.VUE_APP_SYNCFUSION_LICENSE_KEY)


console.log(process.env.NODE_ENV)
const isDev = process.env.NODE_ENV === 'development'
Vue.config.performance = isDev

Vue.use(logger)
Vue.use(alert, { vuetify, i18n })
Vue.use(confirm, { vuetify, i18n })
Vue.use(wordpress, { vuetify, i18n })


Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  cacheLocation: 'localstorage',
  onRedirectCallback: app.authCallback,
  onLoaded: app.authLoaded
})


Vue.component('default-layout', DefaultLayout)
Vue.component('auth-layout', AuthLayout)
Vue.component('error-layout', ErrorLayout)


const vueApp = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
  beforeCreate: app.beforeCreate
}).$mount('#app')


export default vueApp
